(() => {
  const SECTION_SELECTOR = '[data-el-dokumasi]';
  const MOBILE_QUERY = '(max-width: 749px)';

  class ElDokumasiSlider {
    constructor(section) {
      this.section = section;

      this.scrollArea =
        section.querySelector('[data-el-scroll-area]') ||
        section;

      this.slider =
        section.querySelector('[data-el-slider]');

      this.slides = Array.from(
        section.querySelectorAll('[data-el-slide]')
      );

      this.previousButton =
        section.querySelector('[data-el-prev]');

      this.nextButton =
        section.querySelector('[data-el-next]');

      this.paginationButtons = Array.from(
        section.querySelectorAll(
          '[data-el-pagination]'
        )
      );

      this.scrollHint =
        section.querySelector(
          '[data-el-scroll-hint]'
        );

      this.slideCount = this.slides.length;

      this.currentIndex = Math.max(
        0,
        this.slides.findIndex((slide) =>
          slide.classList.contains('is-active')
        )
      );

      this.targetIndex = this.currentIndex;

      this.isAnimating = false;
      this.isProgrammaticScroll = false;
      this.isTouching = false;
      this.mobileSwipeLocked = false;

      this.animationTimer = null;
      this.scrollFrame = null;
      this.resizeTimer = null;
      this.programmaticTimer = null;
      this.swipeLockTimer = null;

      this.touchStartY = 0;
      this.touchCurrentY = 0;
      this.touchStartX = 0;
      this.touchCurrentX = 0;

      this.transitionSpeed =
        this.getTransitionSpeed();

      this.handleScroll =
        this.handleScroll.bind(this);

      this.handleResize =
        this.handleResize.bind(this);

      this.handleKeydown =
        this.handleKeydown.bind(this);

      this.handleTouchStart =
        this.handleTouchStart.bind(this);

      this.handleTouchMove =
        this.handleTouchMove.bind(this);

      this.handleTouchEnd =
        this.handleTouchEnd.bind(this);

      this.init();
    }

    init() {
      if (!this.slideCount) return;

      this.setScrollAreaHeight();
      this.bindEvents();
      this.setActiveSlide(
        this.currentIndex,
        false
      );
      this.updateFromScroll();
    }

    isMobile() {
      return window.matchMedia(
        MOBILE_QUERY
      ).matches;
    }

    getTransitionSpeed() {
      const computedStyle =
        window.getComputedStyle(this.section);

      const value = computedStyle
        .getPropertyValue(
          '--el-transition-speed'
        )
        .trim();

      return (
        Number.parseInt(value, 10) || 700
      );
    }

    bindEvents() {
      window.addEventListener(
        'scroll',
        this.handleScroll,
        { passive: true }
      );

      window.addEventListener(
        'resize',
        this.handleResize,
        { passive: true }
      );

      this.section.addEventListener(
        'keydown',
        this.handleKeydown
      );

      /*
       * Mobilde native momentum scroll yerine
       * kontrollü tek slayt swipe kullanılır.
       */
      this.slider?.addEventListener(
        'touchstart',
        this.handleTouchStart,
        { passive: true }
      );

      this.slider?.addEventListener(
        'touchmove',
        this.handleTouchMove,
        { passive: false }
      );

      this.slider?.addEventListener(
        'touchend',
        this.handleTouchEnd,
        { passive: true }
      );

      this.slider?.addEventListener(
        'touchcancel',
        this.handleTouchEnd,
        { passive: true }
      );

      this.previousButton?.addEventListener(
        'click',
        () => {
          this.scrollToSlide(
            this.currentIndex - 1
          );
        }
      );

      this.nextButton?.addEventListener(
        'click',
        () => {
          this.scrollToSlide(
            this.currentIndex + 1
          );
        }
      );

      this.paginationButtons.forEach(
        (button) => {
          button.addEventListener(
            'click',
            () => {
              const targetIndex = Number(
                button.dataset.slideTarget
              );

              if (
                Number.isNaN(targetIndex)
              ) {
                return;
              }

              this.scrollToSlide(
                targetIndex
              );
            }
          );
        }
      );
    }

    setScrollAreaHeight() {
  if (
    !this.scrollArea ||
    this.scrollArea === this.section
  ) {
    return;
  }

  const viewportHeight =
    window.innerHeight;

  const isMobile =
    this.isMobile();

  let totalHeight;

  if (isMobile) {
    /*
     * Mobil swipe sistemi scroll konumlarını
     * slayt sayısına göre kullandığı için
     * mobil yükseklik aynı kalır.
     */
    totalHeight =
      viewportHeight *
      Math.max(this.slideCount, 1);
  } else {
    /*
     * Masaüstünde her slayt için daha kısa
     * scroll mesafesi kullanılır.
     */
    const scrollDistancePerSlide =
      viewportHeight * 0.35;

    totalHeight =
      viewportHeight +
      Math.max(
        this.slideCount - 1,
        0
      ) *
        scrollDistancePerSlide;
  }

  this.scrollArea.style.height =
    `${Math.round(totalHeight)}px`;
}

    getScrollMetrics() {
      if (!this.scrollArea) return null;

      const rect =
        this.scrollArea.getBoundingClientRect();

      const scrollAreaTop =
        window.scrollY + rect.top;

      const stickyHeight =
        window.innerHeight;

      const scrollableDistance = Math.max(
        this.scrollArea.offsetHeight -
          stickyHeight,
        0
      );

      const passedDistance = Math.min(
        Math.max(
          window.scrollY - scrollAreaTop,
          0
        ),
        scrollableDistance
      );

      const progress =
        scrollableDistance > 0
          ? passedDistance /
            scrollableDistance
          : 0;

      return {
        rect,
        scrollAreaTop,
        scrollableDistance,
        passedDistance,
        progress
      };
    }

    isInsideScrollArea(metrics) {
      if (!metrics) return false;

      const currentScroll = window.scrollY;

      return (
        currentScroll >=
          metrics.scrollAreaTop &&
        currentScroll <=
          metrics.scrollAreaTop +
            metrics.scrollableDistance
      );
    }

    handleScroll() {
      if (this.scrollFrame) return;

      this.scrollFrame =
        window.requestAnimationFrame(() => {
          this.scrollFrame = null;

          /*
           * Mobilde swipe veya kontrollü scroll
           * devam ederken yüzdeye göre yeni bir
           * slayt hesaplanmaz.
           */
          if (
            this.isMobile() &&
            (
              this.isTouching ||
              this.mobileSwipeLocked ||
              this.isProgrammaticScroll
            )
          ) {
            return;
          }

          this.updateFromScroll();
        });
    }

    handleResize() {
      window.clearTimeout(
        this.resizeTimer
      );

      this.resizeTimer =
        window.setTimeout(() => {
          this.setScrollAreaHeight();

          if (
            !this.isProgrammaticScroll
          ) {
            this.updateFromScroll();
          }
        }, 180);
    }

    handleTouchStart(event) {
      if (!this.isMobile()) return;

      if (
        !event.touches ||
        event.touches.length !== 1
      ) {
        return;
      }

      const metrics =
        this.getScrollMetrics();

      if (
        !this.isInsideScrollArea(metrics)
      ) {
        return;
      }

      this.isTouching = true;

      this.touchStartY =
        event.touches[0].clientY;

      this.touchCurrentY =
        this.touchStartY;

      this.touchStartX =
        event.touches[0].clientX;

      this.touchCurrentX =
        this.touchStartX;
    }

    handleTouchMove(event) {
      if (
        !this.isMobile() ||
        !this.isTouching ||
        !event.touches ||
        event.touches.length !== 1
      ) {
        return;
      }

      this.touchCurrentY =
        event.touches[0].clientY;

      this.touchCurrentX =
        event.touches[0].clientX;

      const deltaY =
        this.touchCurrentY -
        this.touchStartY;

      const deltaX =
        this.touchCurrentX -
        this.touchStartX;

      /*
       * Yatay swipe ise müdahale etme.
       */
      if (
        Math.abs(deltaX) >
        Math.abs(deltaY)
      ) {
        return;
      }

      const swipingUp = deltaY < 0;
      const swipingDown = deltaY > 0;

      const canGoNext =
        this.currentIndex <
        this.slideCount - 1;

      const canGoPrevious =
        this.currentIndex > 0;

      /*
       * İlk slaytta aşağı kaydırılıyorsa veya
       * son slaytta yukarı kaydırılıyorsa
       * kullanıcı bölümden çıkabilsin.
       */
      const shouldControlSwipe =
        (swipingUp && canGoNext) ||
        (swipingDown && canGoPrevious);

      if (shouldControlSwipe) {
        event.preventDefault();
      }
    }

    handleTouchEnd() {
      if (
        !this.isMobile() ||
        !this.isTouching
      ) {
        return;
      }

      this.isTouching = false;

      const deltaY =
        this.touchCurrentY -
        this.touchStartY;

      const deltaX =
        this.touchCurrentX -
        this.touchStartX;

      this.touchStartY = 0;
      this.touchCurrentY = 0;
      this.touchStartX = 0;
      this.touchCurrentX = 0;

      /*
       * Yatay hareketleri slayt geçişi sayma.
       */
      if (
        Math.abs(deltaX) >
        Math.abs(deltaY)
      ) {
        return;
      }

      /*
       * Küçük parmak hareketlerini yok say.
       */
      const swipeThreshold = 42;

      if (
        Math.abs(deltaY) <
        swipeThreshold
      ) {
        return;
      }

      if (
        this.mobileSwipeLocked ||
        this.isAnimating
      ) {
        return;
      }

      if (
        deltaY < 0 &&
        this.currentIndex <
          this.slideCount - 1
      ) {
        this.goToMobileSlide(
          this.currentIndex + 1
        );

        return;
      }

      if (
        deltaY > 0 &&
        this.currentIndex > 0
      ) {
        this.goToMobileSlide(
          this.currentIndex - 1
        );
      }
    }

    goToMobileSlide(targetIndex) {
      if (
        targetIndex < 0 ||
        targetIndex >= this.slideCount
      ) {
        return;
      }

      this.mobileSwipeLocked = true;
      this.isProgrammaticScroll = true;

      window.clearTimeout(
        this.swipeLockTimer
      );

      window.clearTimeout(
        this.programmaticTimer
      );

      /*
       * Slayt görselini hemen tek adım değiştir.
       */
      this.setActiveSlide(
        targetIndex,
        true
      );

      /*
       * Sayfanın gerçek scroll konumunu da
       * hedef slaytın merkezine taşır.
       */
      this.scrollWindowToSlide(
        targetIndex,
        'smooth'
      );

      const unlockDelay = Math.max(
        this.transitionSpeed + 250,
        900
      );

      this.swipeLockTimer =
        window.setTimeout(() => {
          this.mobileSwipeLocked = false;
        }, unlockDelay);

      this.programmaticTimer =
        window.setTimeout(() => {
          this.isProgrammaticScroll = false;
        }, unlockDelay);
    }

    handleKeydown(event) {
      const metrics =
        this.getScrollMetrics();

      if (
        !this.isInsideScrollArea(metrics)
      ) {
        return;
      }

      if (
        event.key === 'ArrowDown' ||
        event.key === 'ArrowRight' ||
        event.key === 'PageDown'
      ) {
        if (
          this.currentIndex <
          this.slideCount - 1
        ) {
          event.preventDefault();

          this.scrollToSlide(
            this.currentIndex + 1
          );
        }
      }

      if (
        event.key === 'ArrowUp' ||
        event.key === 'ArrowLeft' ||
        event.key === 'PageUp'
      ) {
        if (
          this.currentIndex > 0
        ) {
          event.preventDefault();

          this.scrollToSlide(
            this.currentIndex - 1
          );
        }
      }
    }

    updateFromScroll() {
      if (
        this.isProgrammaticScroll
      ) {
        return;
      }

      const metrics =
        this.getScrollMetrics();

      if (!metrics) return;
      if (this.slideCount <= 1) return;

      const { progress } = metrics;

      const targetIndex = Math.min(
        this.slideCount - 1,
        Math.max(
          0,
          Math.round(
            progress *
              (this.slideCount - 1)
          )
        )
      );

      if (
        targetIndex !== this.currentIndex
      ) {
        this.setActiveSlide(
          targetIndex,
          true
        );
      }

      if (progress > 0.03) {
        this.hideScrollHint();
      }
    }

    setActiveSlide(
      targetIndex,
      animate = true
    ) {
      if (
        targetIndex < 0 ||
        targetIndex >= this.slideCount
      ) {
        return;
      }

      if (
        targetIndex ===
          this.currentIndex &&
        this.slides[
          targetIndex
        ]?.classList.contains(
          'is-active'
        )
      ) {
        this.updateControls();
        return;
      }

      const oldIndex =
        this.currentIndex;

      const oldSlide =
        this.slides[oldIndex];

      const newSlide =
        this.slides[targetIndex];

      const direction =
        targetIndex > oldIndex
          ? 'next'
          : 'previous';

      this.targetIndex = targetIndex;

      window.clearTimeout(
        this.animationTimer
      );

      if (!animate || !oldSlide) {
        this.slides.forEach(
          (slide, index) => {
            const isActive =
              index === targetIndex;

            slide.classList.toggle(
              'is-active',
              isActive
            );

            slide.classList.remove(
              'is-leaving-up',
              'is-leaving-down'
            );

            slide.setAttribute(
              'aria-hidden',
              isActive
                ? 'false'
                : 'true'
            );
          }
        );

        this.currentIndex =
          targetIndex;

        this.isAnimating = false;

        this.updateControls();

        return;
      }

      this.isAnimating = true;

      /*
       * Önceki animasyonlardan kalan
       * sınıfları bütün slaytlardan temizle.
       */
      this.slides.forEach(
        (slide, index) => {
          if (
            index !== oldIndex &&
            index !== targetIndex
          ) {
            slide.classList.remove(
              'is-active',
              'is-leaving-up',
              'is-leaving-down'
            );

            slide.setAttribute(
              'aria-hidden',
              'true'
            );
          }
        }
      );

      oldSlide.classList.remove(
        'is-active'
      );

      oldSlide.classList.toggle(
        'is-leaving-up',
        direction === 'next'
      );

      oldSlide.classList.toggle(
        'is-leaving-down',
        direction === 'previous'
      );

      oldSlide.setAttribute(
        'aria-hidden',
        'true'
      );

      newSlide.classList.remove(
        'is-leaving-up',
        'is-leaving-down'
      );

      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          newSlide.classList.add(
            'is-active'
          );

          newSlide.setAttribute(
            'aria-hidden',
            'false'
          );
        });
      });

      this.currentIndex =
        targetIndex;

      this.updateControls();
      this.hideScrollHint();

      this.animationTimer =
        window.setTimeout(() => {
          oldSlide.classList.remove(
            'is-leaving-up',
            'is-leaving-down'
          );

          this.isAnimating = false;
        }, this.transitionSpeed + 100);
    }

    scrollWindowToSlide(
      targetIndex,
      behavior = 'smooth'
    ) {
      const metrics =
        this.getScrollMetrics();

      if (!metrics) return;

      const progress =
        this.slideCount > 1
          ? targetIndex /
            (this.slideCount - 1)
          : 0;

      const targetScrollTop =
        metrics.scrollAreaTop +
        metrics.scrollableDistance *
          progress;

      window.scrollTo({
        top: Math.round(
          targetScrollTop
        ),
        behavior
      });
    }

    scrollToSlide(targetIndex) {
      if (
        targetIndex < 0 ||
        targetIndex >= this.slideCount
      ) {
        return;
      }

      this.hideScrollHint();

      if (this.isMobile()) {
        this.goToMobileSlide(
          targetIndex
        );

        return;
      }

      this.isProgrammaticScroll = true;

      window.clearTimeout(
        this.programmaticTimer
      );

      this.setActiveSlide(
        targetIndex,
        true
      );

      this.scrollWindowToSlide(
        targetIndex,
        'smooth'
      );

      this.programmaticTimer =
        window.setTimeout(() => {
          this.isProgrammaticScroll = false;
          this.updateFromScroll();
        }, this.transitionSpeed + 300);
    }

    updateControls() {
      const isFirst =
        this.currentIndex === 0;

      const isLast =
        this.currentIndex ===
        this.slideCount - 1;

      if (this.previousButton) {
        this.previousButton.disabled =
          isFirst;

        this.previousButton.classList.toggle(
          'is-disabled',
          isFirst
        );

        this.previousButton.setAttribute(
          'aria-disabled',
          isFirst
            ? 'true'
            : 'false'
        );
      }

      if (this.nextButton) {
        this.nextButton.disabled =
          isLast;

        this.nextButton.classList.toggle(
          'is-disabled',
          isLast
        );

        this.nextButton.setAttribute(
          'aria-disabled',
          isLast
            ? 'true'
            : 'false'
        );
      }

      this.paginationButtons.forEach(
        (button, index) => {
          const isActive =
            index === this.currentIndex;

          button.classList.toggle(
            'is-active',
            isActive
          );

          button.setAttribute(
            'aria-current',
            isActive
              ? 'true'
              : 'false'
          );
        }
      );
    }

    hideScrollHint() {
      this.scrollHint?.classList.add(
        'is-hidden'
      );
    }

    destroy() {
      window.clearTimeout(
        this.animationTimer
      );

      window.clearTimeout(
        this.resizeTimer
      );

      window.clearTimeout(
        this.programmaticTimer
      );

      window.clearTimeout(
        this.swipeLockTimer
      );

      if (this.scrollFrame) {
        window.cancelAnimationFrame(
          this.scrollFrame
        );
      }

      window.removeEventListener(
        'scroll',
        this.handleScroll
      );

      window.removeEventListener(
        'resize',
        this.handleResize
      );

      this.section.removeEventListener(
        'keydown',
        this.handleKeydown
      );

      this.slider?.removeEventListener(
        'touchstart',
        this.handleTouchStart
      );

      this.slider?.removeEventListener(
        'touchmove',
        this.handleTouchMove
      );

      this.slider?.removeEventListener(
        'touchend',
        this.handleTouchEnd
      );

      this.slider?.removeEventListener(
        'touchcancel',
        this.handleTouchEnd
      );

      delete this.section.dataset
        .elInitialized;

      delete this.section
        .elDokumasiInstance;
    }
  }

  const initializeSection = (section) => {
    if (!section) return;

    if (
      section.dataset.elInitialized ===
      'true'
    ) {
      return;
    }

    section.dataset.elInitialized =
      'true';

    section.elDokumasiInstance =
      new ElDokumasiSlider(section);
  };

  const initializeAll = (
    container = document
  ) => {
    if (
      container.matches?.(
        SECTION_SELECTOR
      )
    ) {
      initializeSection(container);
    }

    container
      .querySelectorAll?.(
        SECTION_SELECTOR
      )
      .forEach(initializeSection);
  };

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        initializeAll();
      }
    );
  } else {
    initializeAll();
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initializeAll(event.target);
    }
  );

  document.addEventListener(
    'shopify:section:unload',
    (event) => {
      const section =
        event.target.matches?.(
          SECTION_SELECTOR
        )
          ? event.target
          : event.target.querySelector?.(
              SECTION_SELECTOR
            );

      section?.elDokumasiInstance
        ?.destroy();
    }
  );

  document.addEventListener(
    'shopify:block:select',
    (event) => {
      const block =
        event.target.closest(
          '[data-el-slide]'
        );

      const section =
        event.target.closest(
          SECTION_SELECTOR
        );

      if (
        !block ||
        !section?.elDokumasiInstance
      ) {
        return;
      }

      const index = Number(
        block.dataset.slideIndex
      );

      if (Number.isNaN(index)) return;

      section.elDokumasiInstance
        .scrollToSlide(index);
    }
  );
})();